import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=4eaf7af1&scoped=true&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"
import style0 from "./purchase.vue?vue&type=style&index=0&id=4eaf7af1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaf7af1",
  null
  
)

export default component.exports